<template>
  <v-layout row wrap>
    <v-flex xs12 class="text-xs-center">
      <v-alert v-if="user.expertise.length<1" :value="true" type="info">What expert/skill are you looking for?</v-alert>
      <!-- start of modal -->
      <v-dialog v-model="dialog" max-width="850px">
        <v-btn color="btnColor" dark slot="activator" class="mb-2" flat>
          <v-icon>add</v-icon>Add Expertise
        </v-btn>
        <v-card>
          <v-toolbar color="primary" flat dense dark>
            <v-toolbar-title class="title">Expertise</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="mx-0" icon @click="close">
              <v-icon color="white">clear</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-flex xs12>
                <v-autocomplete
                  autoUpdate
                  v-model="selectedCategories"
                  :disabled="isUpdating"
                  :items="categories"
                  chips
                  label="Select"
                  item-text="category"
                  item-value="category"
                  required
                >
                  <!-- multiple -->
                  <template v-slot:selection="data">
                    <v-chip
                      :selected="data.selected"
                      close
                      class="chip--select-multi"
                      @input="remove(data.item)"
                    >{{ data.item.category }}</v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-tile-content v-text="data.item"></v-list-tile-content>
                    </template>
                    <template v-else>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="data.item.category"></v-list-tile-title>
                        <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex xs12>
                <v-btn class="btnColor" dark @click="saveExpertise">
                  <v-icon left>save</v-icon>Save
                </v-btn>
              </v-flex>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-snackbar
        :timeout="timeout"
        top
        right
        v-model="expertiseSnackbar"
        color="red"
      >{{ expertiseError }}</v-snackbar>
      <!-- end of modal -->
    </v-flex>

    <v-flex xs12 class="text-xs-left">
      <div style="font-size: 18px;">
        <ul>
          <li
            v-for="(expertise, index) in user.expertise"
            v-bind:key="index"
          >{{expertise.category}}</li>
        </ul>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SonkoExpertise",
  computed: {
    ...mapGetters(["user"])
  },
  data() {
    return {
      autoUpdate: true,
      dialog: false,
      selectedCategories: '',
      expertiseSnackbar: false,
      expertiseError: "Please select expertise",
      timeout: 4000,
      categories: [],
      isUpdating: false
    };
  },
  methods: {
    saveExpertise() {
      const expertise = [this.selectedCategories];
      if (this.selectedCategories == '') {
        this.expertiseSnackbar = true;
      } else {
        const newArray = expertise.map(record=>{
          return {category: record};
        });

        const data = {
          expertise: newArray
        };
        // dispatch
        const self = this;
        const res = this.$store
          .dispatch("put", { url: "/user/update/" + this.user._id, data })
          .then(res => {
            self.$store.commit("setUser", res.user);
            localStorage.setItem('token', res.token);
            self.dialog = false;
             if(res.state==true){
              if(res.user.accountType=='expert'){
                self.$router.push('/expert/profile');
              }else if(res.user.accountType=='sonko'){
                self.$router.push('/sonko/profile');
              }
            }
          });
      }
    },
    close() {
      this.dialog = false;
    },
    remove(item) {
      this.selectedCategories = '';
    }
  },
  watch: {
    isUpdating(val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000);
      }
    }
  },
  created() {
    this.$store.dispatch("get", "/expertise").then(res => {
      this.categories = res.expertiseCategories;
    });
  }
};
</script>